import React, { useEffect, useState } from "react";
import '../blogs/blog.css';
import { NavLink } from "react-router-dom";
import { fetchAllPosts } from "./api";
import Nav from "../nav";
import Footer from "../footer";

function Blog() {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getPosts = async () => {
            setLoading(true);
            try {
                console.log("Fetching posts for category ID:");

                const postsData = await fetchAllPosts();

                setPosts(postsData);
            } catch (error) {
                console.error('Error fetching posts for category:', error);
            } finally {
                setLoading(false);
            }
        };

        getPosts();
    }, []);

    if (loading) {
        return <p>Loading posts...</p>;
    }

    function formatDate(dateString) {
        const date = new Date(dateString);
        return date.toLocaleString("en-IN", {
            dateStyle: "medium"
        });
    }

    return (
        <>
            <Nav />

            <div className="container">



                <div className='row listingpadding'>
                    {posts.map((post) => (
                        <div className='col-sm-12 col-md-9 col-lg-3 recentPosts' key={post.id}>
                            <NavLink to={`/blogs/${post.slug}`} target="_blank">

                                <img src={post.featuredImage} alt={post.title.rendered} className="blog-thumb" />
                            </NavLink>
                            {/* <span className='tagline'>{categoryName}</span> */}
                            <NavLink className="decoration" to={`/blogs/${post.slug}`} target="_blank">
                                {/* <h5>{post.title.rendered}</h5> */}
                                <h5 dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
                            </NavLink>
                            <div className="in_row">
                                <div className='editor'>Staveo Tech  &nbsp;|</div> &nbsp;&nbsp;
                                <div className='date'>  {formatDate(post.date)}</div>
                            </div>
                            <p className="excerpt" dangerouslySetInnerHTML={{ __html: post.excerpt.rendered }} ></p>
                            <NavLink to={`/blogs/${post.slug}`} target="_blank"> <div className='read_more'>Read More</div></NavLink>
                        </div>


                    ))}
                </div>

            </div>
            <Footer />
        </>
    )
}

export default Blog;